// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  Container,
  Row,
  Button,
  Col,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Spinner,
  Form,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import CustomTable from "components/CustomTable";
import { toast } from "react-toastify";
import {
  useCreateAdmin,
  useDeleteAdmin,
  useGetAllAdmins,
} from "utils/auth.api";
import ReactPaginate from "react-paginate";

const AdminManagement = () => {

  const createAdminMutation = useCreateAdmin();
  const deleteAdminMutation = useDeleteAdmin();
  // const deleteAdminRegistrationMutation = useDeleteAdmin();
  const columns = ["id", "Name", "Email", "Actions"];
  const [adminId, setAdminId] = useState("");
  const [rows, setRows] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [filteredAdmins] = useState();
  const [addAdminFormData, setAddAdminFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "ADMIN",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const { isLoading, data, error } = useGetAllAdmins({
    limit: itemsPerPage,
    offset: currentPage * itemsPerPage,
  });
  // const getAdminsBypasswordMutation = useGetAdminsBypassword({
  //   limit: itemsPerPage,
  //   offset: currentPage * itemsPerPage,
  // });

  // const { data: passwordData } = useGetAllpasswords({
  //   limit: 1000,
  //   offset: 0,
  // });
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const addToggle = () => setAddModal(!addModal);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddAdminFormData({ ...addAdminFormData, [name]: value });
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();
    // console.log("Form Data:", addAdminFormData);
    try {
      createAdminMutation.mutateAsync(addAdminFormData);
      toast.success("Admin Created");
      addToggle();

      setAddAdminFormData({
        name: "",
        email: "",
        role: "ADMIN",
      });
    } catch (error) {
      toast.error(error?.message);
    }
  };

  // const handleFilterSubmit = async () => {
  //   try {
  //     const admins = await getAdminsBypasswordMutation.mutateAsync({
  //       password: filterOrg,
  //     });
  //     setFilteredAdmins(admins);
  //     setFilterOrg("");
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // };

  const reArrageData = (e) => {
    let tempArr = [];

    e?.admins?.forEach((item, idx) => {
      if (item?.role === "superadmin") {
        tempArr?.push({
          id: item.id,
          name: item?.name,
          email: item?.email,
          actions: (
            <>
              <Button
                size="sm"
                color="danger"
                onClick={() => {
                  deleteToggle();
                  setAdminId(item?.id);
                }}
              >
                <i className="fas fa-user-times"></i>
              </Button>
            </>
          ),
        });
      }
    });
    setRows(tempArr);
  };

  useEffect(() => {
    if (data) {
      reArrageData(data);
      setTotalCount(data.totalCount);
    }

    if (filteredAdmins?.admins?.length > 0) {
      reArrageData(filteredAdmins);
      setTotalCount(filteredAdmins.totalCount);
    }

    if (error) {
      toast.error(error?.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filteredAdmins, currentPage]);
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Button
              className="d-block ml-auto mb-2"
              color="secondary"
              onClick={() => {
                addToggle();
              }}
            >
              Add Admin
            </Button>

            <Card className="shadow">
              <CardHeader className="border-0 px-0 px-md-2 d-flex align-items-center">
                <Col xs="auto">
                  <h3 className="mb-0">Admins</h3>
                </Col>
              </CardHeader>
              {isLoading ? (
                <Spinner size="lg" className="my-5 mx-auto" />
              ) : (
                <CustomTable columns={columns} rows={rows} />
              )}
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  // style={paginationContainerStyles}
                  >
                    <ReactPaginate
                      previousLabel={
                        <i
                          className="previous fa fa-chevron-left"
                          aria-hidden="true"
                        ></i>
                      }
                      nextLabel={
                        <i
                          className="next fa fa-chevron-right"
                          aria-hidden="true"
                        ></i>
                      }
                      breakLabel={"..."}
                      pageCount={Math.ceil(totalCount / itemsPerPage)}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-end mb-0"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      activeClassName={"active"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
        <Modal isOpen={addModal} toggle={addToggle}>
          <ModalHeader className="pb-0">Add Admin</ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center">
            <Form onSubmit={handleAddSubmit}>
              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Name</Label>
                  <Input
                    placeholder="Enter admin's name"
                    name="name"
                    required
                    value={addAdminFormData.name}
                    onChange={handleAddInputChange}
                  />
                </FormGroup>
                <FormGroup className="w-100">
                  <Label>Email</Label>
                  <Input
                    placeholder="Enter admin's email"
                    type="email"
                    name="email"
                    required
                    value={addAdminFormData.email}
                    onChange={handleAddInputChange}
                  />
                </FormGroup>
                <FormGroup className="w-100">
                  <Label>Password</Label>
                  <Input
                    type="text"
                    className="p-2"
                    name="password"
                    required
                    placeholder="Add password for admin"
                    value={addAdminFormData.password}
                    onChange={handleAddInputChange}
                  />
                </FormGroup>
              </Row>
              <Button color="danger" type="submit" className="w-100 mt-4">
                Add
              </Button>{" "}
              <Button
                color="secondary"
                onClick={addToggle}
                className="w-100 mt-4 mb-4"
              >
                Cancel
              </Button>
            </Form>
          </ModalBody>
        </Modal>
        <Modal isOpen={deleteModal} toggle={deleteToggle}>
          <ModalHeader className="pb-0">Delete Admin Profile</ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center ">
            <Row>
              <i
                className="fa fa-times-circle fa-3x fa-primary"
                style={{
                  color: "#D7B665",
                }}
                aria-hidden="true"
              ></i>
            </Row>
            <Row className="mt-4">
              Are you sure about deleting this Profile?
            </Row>
            <Button
              color="danger"
              onClick={async () => {
                try {
                  await deleteAdminMutation.mutateAsync(adminId);

                  toast.success("Profile deleted successfully!!!");
                } catch (error) {
                  toast.error("Error deleting admin!!!");
                }
                deleteToggle();
              }}
              className="w-100 mt-4"
            >
              Delete
            </Button>{" "}
            <Button
              color="secondary"
              onClick={deleteToggle}
              className="w-100 mt-4 mb-4"
            >
              Cancel
            </Button>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default AdminManagement;
